import { Uuid } from '@ftr/contracts/type/shared'

/**
 * Branded tenant identifier types.
 *
 * These are `Uuid` at runtime (no extra field, no serialization cost) but are not
 * mutually assignable to each other at compile time, so a `CourtSystemId` can't be
 * accidentally passed where an `OrganizationId` is expected, etc.
 *
 * A plain `Uuid` IS assignable INTO any of these (so existing call sites that already
 * pass a raw court system id continue to work unchanged), but these are NOT assignable
 * back to a plain `Uuid` implicitly - you may need a cast at the few places a branded id
 * is handed to code that still expects a bare `Uuid`.
 */
// eslint-disable-next-line @typescript-eslint/naming-convention
export type CourtSystemId = Uuid & { readonly _tenantBrand: 'CourtSystemId' }
// eslint-disable-next-line @typescript-eslint/naming-convention
export type OrganizationId = Uuid & { readonly _tenantBrand: 'OrganizationId' }
// eslint-disable-next-line @typescript-eslint/naming-convention
export type IndividualId = Uuid & { readonly _tenantBrand: 'IndividualId' }

export function asCourtSystemId(id: Uuid): CourtSystemId {
  return id as CourtSystemId
}

export function asOrganizationId(id: Uuid): OrganizationId {
  return id as OrganizationId
}

export function asIndividualId(id: Uuid): IndividualId {
  return id as IndividualId
}
